import classNames from 'classnames';
import { Copy } from '@phosphor-icons/react';
import '../../../../css/clipboard.less';
import ComponentWithTooltip from '../generic/tooltip/ComponentWithTooltip';
import translations from '../../translations';

interface Props {
    value: string;
    id?: string;
    buttonTitle?: string;
    placeholder?: string;
    inputClassName?: string;
}

const ClipboardInput = ({
    value,
    id,
    buttonTitle = translations.CLIPBOARD_INPUT_copy_to_clipboard_button_label,
    placeholder,
    inputClassName,
}: Props) => {
    const inputClasses = classNames(inputClassName, {
        'grouped-control-input': true,
    });

    return (
        <div className="grouped-control" data-testid="clipboard-input">
            <input
                id={id}
                className={inputClasses}
                readOnly
                onClick={({ currentTarget }) => currentTarget.select()}
                value={value}
                size={60}
                placeholder={placeholder}
            />
            <ComponentWithTooltip
                trigger={'click'}
                hideDelay={1000}
                fadeTime={0.2}
                tooltipContent="Copied"
            >
                <button
                    id="clipboard-input-button"
                    className="grouped-control-extension clipboard-copy"
                    title={buttonTitle}
                    onClick={() => navigator.clipboard.writeText(value)}
                    type="button"
                >
                    <Copy />
                </button>
            </ComponentWithTooltip>
        </div>
    );
};

export default ClipboardInput;
